export class Type {
    constructor(
            public id: number = null,
            public name: string = null,
            public mask: string = null,
            public placeholder: string = null,
            public style: string = null) { }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/type.ts